import { notificationInitialState } from "./notificationState";
import { makeNotificationActions } from "./notificationActions";

export const createNotificationSlice = (set, get) => ({
  notification: notificationInitialState,
  notificationActions: Object.freeze(makeNotificationActions(set, get)),
});
